import DisplayField from '@/components/ui/DisplayField'
import EditActions from '@/components/ui/EditActions'
import resizing from '@/mixins/resizing'
import validate from '@/mixins/validate'
import masks from '@/mixins/masks'

export default {
  components: { DisplayField, EditActions },
  mixins: [resizing, validate, masks],
  props: {
    items: {
      type: [Object, Array],
      required: false
    },
    submitLabel: {
      type: String,
      default: 'Salvar'
    },
    btnCancelLabel: {
      type: String,
      default: 'Cancelar'
    },
    btnCancelShow: {
      type: Boolean,
      default: false
    },
    btnPosition: {
      type: String,
      default: 'right'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideSubmit: {
      type: Boolean,
      default: false
    },
    displayMode: {
      type: Boolean,
      default: false
    },
    actionsEdit: {
      type: Boolean,
      default: false
    },
    autoHeight: {
      type: Boolean,
      default: false
    },
    btnOutline: {
      type: Boolean,
      default: false
    },
    btnBlock: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      valid: true,
      isDisabled: false,
      dataItems: {},
      isDisplayMode: true
    }
  },
  methods: {
    submit () {
      if (this.$refs.form.validate()) {
        this.$emit('submit', this.dataItems)
        this.isDisabled = this.editAction
      }
    },
    edit () {
      this.$emit('edit')
    },
    cancel () {
      this.$emit('cancel')
    },
    changeDisplay (status) {
      this.isDisplayMode = status
    },
    save () {
      if (this.$refs.form.validate()) {
        this.$emit('save', this.dataItems)
        this.isDisplayMode = true
      }
    }
  },
  computed: {
    setAutoHeight () {
      return this.autoHeight ? this.setHeightScroll : ''
    },
    setStyleEditMode () {
      return this.actionsEdit ? 'margin-top: -47px' : ''
    }
  },
  watch: {
    isDisplayMode (val) {
      this.$emit('displayMode', val)
    },
    items (val) {
      // this.isDisplayMode = true
      this.dataItems = val
    }
  },
  mounted () {
    this.isDisplayMode = this.displayMode
  }
}
